import React, { useState } from "react";
import { Button } from "@material-ui/core";
import Grid from '@mui/material/Grid';
import DeleteModel from './deleteModel'
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";

export default function ButtonComponent(props) {
    let navigate = useNavigate();
    const direct = () => {
        navigate("/dashboard");
      };
    const axios = useAxiosPrivate()
    const { isValid, edit, setEdit, group, setAlert, loadDataGroupData, userValue, initialValues, setOpenMessage, setDeleteTeam } = props
    const [open, setOpen] = useState(false);
    const handlemodelOpen = () => {
        setOpen(true)
    }
    const updateTeam = async () => {
        try {
            await axios.post(`/group/update/${group}`, {
                name: initialValues.teamName,
                category_id: initialValues.category_id ? initialValues.category_id : null,
                category: initialValues.name
            });
            loadDataGroupData()
            setEdit(false)
            setAlert({
                showAlert: true,
                severity: 'Success',
                message: 'Team update Successfully!',
            });
            setOpenMessage(true)
            setTimeout(() => {
                setAlert({
                    showAlert: false,
                    severity: 'Success',
                    message: 'Team update Successfully!',
                });
            }, 5000);
        } catch (error) {
            if (error.response && error.response?.data) {
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: error.response?.data?.message,
                });
                setOpenMessage(true)
            } else {
                setAlert({
                    showAlert: true,
                    severity: 'error',
                    message: 'Something error!',
                });
                setOpenMessage(true)
            }
        }
    };

    return (
        <>
            <DeleteModel setOpen={setOpen} open={open} group={group} setAlert={setAlert} loadDataGroupData={loadDataGroupData} setDeleteTeam={setDeleteTeam} />
            <Grid item md={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                {group === "default" ?
                    <Button
                        fullWidth
                        disabled={!(isValid && userValue?.length > 0)}
                        variant='contained'
                        color="primary"
                        type='submit'
                        size='large'
                        style={{
                            fontSize: '0.9rem',
                            lineHeight: '1.25rem',
                            fontFamily: 'Poppins',
                            fontWeight: 500,
                            fontStyle: 'normal',
                            width: 80,
                            height: 35,
                            color: "white",
                            textTransform: "capitalize",
                        }}
                    >
                        save
                    </Button>
                    : group !== '' ?
                        !edit ?
                            <>
                                <Button
                                    color="primary"
                                    fullWidth
                                    onClick={() => setEdit(true)}
                                    size='large'
                                    style={{
                                        fontSize: '0.9rem',
                                        lineHeight: '1.25rem',
                                        fontFamily: 'Poppins',
                                        fontWeight: 500,
                                        fontStyle: 'normal',
                                        width: 80,
                                        height: 35,
                                        textTransform: "capitalize",
                                        border: "2px solid",
                                        marginRight: "0.5rem"
                                    }}
                                >
                                    Edit
                                </Button>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    fullWidth
                                    size='large'
                                    onClick={() => handlemodelOpen()}
                                    style={{
                                        fontSize: '0.9rem',
                                        lineHeight: '1.25rem',
                                        fontFamily: 'Poppins',
                                        fontWeight: 500,
                                        fontStyle: 'normal',
                                        width: 80,
                                        height: 35,
                                        textTransform: "capitalize",
                                    }}
                                >
                                    Delete
                                </Button>
                            </> : <>
                                <Button
                                    color="primary"
                                    fullWidth
                                    onClick={direct}
                                    size='large'
                                    style={{
                                        fontSize: '0.9rem',
                                        lineHeight: '1.25rem',
                                        fontFamily: 'Poppins',
                                        fontWeight: 500,
                                        fontStyle: 'normal',
                                        width: 80,
                                        height: 35,
                                        textTransform: "capitalize",
                                        border: "2px solid",
                                        marginRight: "0.5rem"
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={() => updateTeam()}
                                    disabled={!(isValid && userValue?.length > 0)}
                                    size='large'
                                    style={{
                                        fontSize: '0.9rem',
                                        lineHeight: '1.25rem',
                                        fontFamily: 'Poppins',
                                        fontWeight: 500,
                                        fontStyle: 'normal',
                                        width: 80,
                                        height: 35,
                                        textTransform: "capitalize",
                                    }}
                                >
                                    save
                                </Button>
                            </>
                        :
                        null}
            </Grid>
        </>
    );
}
